import React from 'react';
import {ItemProps} from '../ItemProps';
import {ItemGridTile} from './ItemGridTile';
import {ItemsGridContainer} from './ItemGrid.style';
import {generateIdentifier} from '../../../utils/IdentityUtils';

/**
 * @name ItemGrid
 * @description
 * Component to show download items (folder/file) for the grid visualisation.
 */
export const ItemGrid = (props: ItemProps) => {
    return (
        <ItemsGridContainer id={generateIdentifier()}>
            {props.items.map(item => (
                <ItemGridTile key={item.id}
                              item={item}
                              language={props.language}
                              defaultLocale={props.defaultLocale}
                              showEdit={props.editMode}
                              isFavoriteToggle={props.favoriteItems.includes(item.id)}
                              labelData={props.labelData ?? []}
                              onDetailsClicked={() => props.onShowDetails(item)}
                              onEditClicked={() => props.onEdit(item)}
                              onDeleteClicked={() => props.onDelete(item)}
                              onDownloadClicked={() => props.onDownload(item)}
                              onFavoriteClicked={() => props.onMarkAsFavorite(item, props.favoriteItems)}
                              onClick={() => props.onItemSelect(item)}
                              onPreviewClicked={() => props.onShowPreview(item)}
                              onCopyUrlClicked={() => props.onCopyUrl(item)}/>
            ))}
        </ItemsGridContainer>
    );
};
